import { OrdersModel } from '@pukka/api';
import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

import { invoiceReceiptDateTime } from './utils';

interface ReceiptTotalProps {
  readonly invoiceDetail: OrdersModel.OrderDetail;
}

const { formatCurrency } = numberUtils;

export default function ReceiptTotal({ invoiceDetail }: ReceiptTotalProps) {
  return (
    <div>
      <div className="flex justify-between px-4 py-2">
        <Text weight="semibold">Total</Text>
        <Text weight="semibold" className="w-40 text-right">
          {formatCurrency(invoiceDetail.total_collected_amount, 'Rp.')}
        </Text>
      </div>
      <hr />
      {invoiceDetail.invoice_payment_records.map((payment, idx) => (
        <div key={idx} className="flex justify-between px-4 py-1">
          <Text variant="body-1">Paid on {invoiceReceiptDateTime(payment.payment_date, 'date')}</Text>
          <Text variant="body-1" className="w-40 text-right">
            {formatCurrency(payment.amount_received, 'Rp.')}
          </Text>
        </div>
      ))}
      <hr />
      <div className="flex justify-between px-4 py-2 text-red-500">
        <Text weight="semibold">Amount Due</Text>
        <Text weight="semibold" className="w-40 text-right">
          {formatCurrency(invoiceDetail.total_amount_due, 'Rp.')}
        </Text>
      </div>
    </div>
  );
}
